import Stack from "@mui/material/Stack"
import Skeleton from "@mui/material/Skeleton"
import { Fragment } from "react"
import Typography from "@mui/material/Typography"

import Divider from '@mui/material/Divider';
/** we are using this component to display when no data is available in table. This avoid error boundry to thow an error and makes user exp better. */
export const NoTableDataComp = () => {
    return (
        <Fragment>
            <Divider />
            <Stack>
                <Typography variant="body" align="center" sx={{ p: '10px', color: 'gray' }}>
                    {`No Data Available to present. Please create new entry or try after sometime.`}
                </Typography>
            </Stack>
        </Fragment>)
}
export default NoTableDataComp
